module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/recruit_top_img_mb-c95d2ab3206a65e4975318e16ddba57a.png";